import React from 'react';
const SvgXltx = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M41 6V3H12v39h3v3h29V6z" />
      <path fill="#217346" d="M41 3H12v6h29V5l3 3V6z" />
      <path fill="#949494" d="M43 7v37H16v-2h25V9h-1v32H13V9h-1v33h3v3h29V8z" />
      <path fill="#217346" d="M4 17l20-3v26L4 37z" />
      <path
        fill="#FFF"
        d="M19 33h-2.882l-1.858-3.908c-.07-.145-.143-.413-.219-.803h-.03a6.61 6.61 0 01-.248.837L11.897 33H9l3.439-6-3.145-6h2.957l1.542 3.598c.12.285.228.623.324 1.013h.03c.06-.234.173-.583.338-1.046L16.201 21h2.709l-3.236 5.95L19 33z"
      />
      <path
        fill="#C8C8C8"
        d="M30 36h7v2h-7zM24 36h4v2h-4zM30 32h7v2h-7zM24 32h4v2h-4zM30 28h7v2h-7zM24 28h4v2h-4zM30 24h7v2h-7zM24 24h4v2h-4zM30 20h7v2h-7zM24 20h4v2h-4zM30 16h7v2h-7zM24 16h4v2h-4z"
      />
      <linearGradient id="xltx_svg__a" gradientUnits="userSpaceOnUse" x1={14} y1={39.188} x2={14} y2={14.758}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#xltx_svg__a)" d="M24 14L4 17v20l20 3z" />
      <linearGradient id="xltx_svg__b" gradientUnits="userSpaceOnUse" x1={17.754} y1={42.918} x2={18.177} y2={38.93}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#xltx_svg__b)" d="M24 43H12v-4.8L24 40z" />
      <linearGradient id="xltx_svg__c" gradientUnits="userSpaceOnUse" x1={12.999} y1={8.22} x2={40.001} y2={42.781}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xltx_svg__c)" d="M12 9h29v33H12z" />
      <linearGradient id="xltx_svg__d" gradientUnits="userSpaceOnUse" x1={23.428} y1={18.729} x2={43.971} y2={45.022}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xltx_svg__d)" d="M41 5v37H15v3h29V8z" />
      <linearGradient id="xltx_svg__e" gradientUnits="userSpaceOnUse" x1={28} y1={44.906} x2={28} y2={42.087}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xltx_svg__e)" d="M15 42h26v3H15z" />
      <linearGradient id="xltx_svg__f" gradientUnits="userSpaceOnUse" x1={27.839} y1={8.577} x2={28.166} y2={2.34}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#xltx_svg__f)" d="M41 3H12v6h29V5l3 3V6z" />
    </svg>
  );
});
export default SvgXltx;
SvgXltx.iconName = 'xltx';
SvgXltx.displayName = 'SvgXltx';
